var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.83331 0 0 .83331 3.4889 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.357 2.1132h-5.2897c0-1.1597-0.96054-2.1132-2.1198-2.1132h-1.4117c-1.1597 0-2.1197 0.95351-2.1197 2.1132h-5.296c-1.1597 0-2.1198 0.96061-2.1198 2.1196v0.30291c0 0.22422 0.18306 0.4004 0.40535 0.4004h19.619c0.2243 0 0.40032-0.18314 0.40032-0.4004v-0.30291c0.05028-1.1597-0.87712-2.1196-2.0682-2.1196",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.509 11.166c0-0.52783 0.42547-0.95351 0.95351-0.95351 0.52806 0 0.9666 0.42547 0.9666 0.95351v8.0407c0 0.53479-0.43855 0.96054-0.9666 0.96054-0.52806 0-0.95351-0.42547-0.95351-0.96054zm5.6247 0c0-0.52783 0.42547-0.95351 0.95351-0.95351 0.5351 0 0.96054 0.42547 0.96054 0.95351v8.0407c0 0.53479-0.42547 0.96054-0.96054 0.96054-0.52806 0-0.95351-0.42547-0.95351-0.96054zm-10.315 10.715c0 1.167 0.96054 2.1196 2.1199 2.1196h12.68c1.1597 0 2.1198-0.95351 2.1198-2.1196v-15.476h-16.919z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6b4126e08cf529ad4ee30c7281ba2753.svg";
export { ForwardRef as ReactComponent };